module.exports = __webpack_public_path__ + "static/media/997669.bda1eb9c.jpg";